module.exports = __webpack_public_path__ + "e7f3253d025e3517f61dc8b8472c4841.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-lines-blue-s.png
// module id = 1373
// module chunks = 0